<template>
  <div class="ed-wrap">
    <modal name="question" class="ed-modal" @before-close="onClose" :adaptive="true" height="auto" width="90%" :maxWidth="620">
      <div class="ed-dialog">
        <div class="ed-dialog-header">
          <div class="ed-dialog-header-left">
            <span class="ed-dialog-icon">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                <path d="M3 3v18h18"/>
                <path d="M7 15l4-4 3 3 5-7"/>
              </svg>
            </span>
            <div>
              <h2 class="ed-dialog-title">Edit Distance</h2>
              <p class="ed-dialog-sub">{{ finishDate }} · {{ race.duration }} · {{ race.name }}</p>
            </div>
          </div>
          <button class="ed-close-btn" type="button" title="Close" @click="$modal.hide('question')">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
          </button>
        </div>
        <div class="ed-dialog-body">
          <div class="ed-current-distance">{{ race.distance }}</div>
          <label class="ed-field">
            <span class="ed-label">Distance</span>
            <div class="ed-input-unit">
              <input type="number" v-model="newdistance" id="save-distance-input" maxlength="255" name="newdistance" placeholder="0.00" class="ed-input">
              <span class="ed-unit">Km</span>
            </div>
          </label>
        </div>
        <div class="ed-dialog-footer">
          <button class="ed-cancel-btn" type="button" @click="$modal.hide('question')">Cancel</button>
          <button class="ed-save-btn" id="save-distance" type="button" v-on:click="Save(newdistance)">Save</button>
        </div>
      </div>
    </modal>  
  </div>
  
</template>

<script>
  import RunnersByRaceService from '../../../services/runnersByRace'
  import { db } from '../../../firebase'

  export default {
    name: 'edit-distance',
    data: () => ({
        newdistance:'',
        finishDate: ''
    }),
    props:{
            race: {
                type:Object
            },
            show:false,
        },
    // firebase: {
    //   ${this.$fbDbEntry}: db.ref('${this.$fbDbEntry}')
    // },
    methods: {
      onClose() {
              this.$emit('closed', true)
      },
      openEditModal() {
        this.finishDate  = this.race.finishDate.slice(5)
        this.$modal.show('question')
      },
      Save (distance) {
        let  that = this
        let data1 = {
          raceId :  this.race.id,
          race :{
            runnerId: this.race.runnerId,
            distance: parseFloat(distance)*1000
          }
        }
        this.saveButton()
        RunnersByRaceService.updateDistance(data1).then((response) => {
          db.ref(`${this.$fbDbEntry}`).child(this.race.id).child("runners").child(this.race.runnerId).update({
            "distance": parseFloat(distance)*1000
          }).then(function(){
            let data = {
              raceId :  that.race.id,
              runnerId: that.race.runnerId,
              distance: parseFloat(distance)
            }
            that.resetSaveButton()
            that.$emit('saved', data)
            that.$modal.hide('question')
            that.newdistance = ''
          }).catch(function(error) {
            that.resetSaveButton()
            console.log(error)
          })
        })    
      },
    saveButton() {
        const btnsave = document.querySelector('#save-distance')
        btnsave.innerHTML = 'Saving...'
        btnsave.setAttribute('disabled', true)
      },
    resetSaveButton() {
        const btnsave = document.querySelector('#save-distance')
        btnsave.innerHTML = 'Save'
        btnsave.removeAttribute('disabled', true)
    },



    },
    created() {
     this.$watch('show', function (val) {
      })
    },
    
    watch: {
        show(oldVal, newVal) {
            if(this.show){
             this.openEditModal()
            }
        }
    },
  }
</script>
<style scoped>
.ed-dialog {
  background: #fff;
  border-radius: 10px;
  overflow: hidden;
}
.ed-dialog-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  padding: 1.2rem 1.75rem;
  border-bottom: 1px solid #f0f0f5;
}
.ed-dialog-header-left {
  display: flex;
  align-items: center;
  gap: 12px;
}
.ed-dialog-icon {
  width: 36px;
  height: 36px;
  border-radius: 10px;
  background: #f0effe;
  color: #5b4fcf;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
.ed-dialog-title {
  font-size: 16px;
  font-weight: 700;
  color: #1a1a2e;
  margin: 0;
}
.ed-dialog-sub {
  font-size: 12px;
  color: #8a8a9a;
  margin: 4px 0 0;
}
.ed-close-btn {
  width: 30px;
  height: 30px;
  border-radius: 8px;
  border: 1px solid #e8e8ed;
  background: #fff;
  color: #8a8a9a;
  cursor: pointer;
}
.ed-close-btn:hover {
  color: #c0392b;
  border-color: #ffd6d6;
}
.ed-dialog-body {
  padding: 1.5rem 1.75rem;
  display: flex;
  flex-direction: column;
  gap: 1.1rem;
}
.ed-current-distance {
  color: #c0392b;
  font-size: 13px;
  font-weight: 700;
}
.ed-field {
  display: flex;
  flex-direction: column;
  gap: 0.45rem;
}
.ed-label {
  font-size: 12px;
  font-weight: 600;
  color: #1a1a2e;
}
.ed-input-unit {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}
.ed-input {
  height: 40px;
  width: 220px;
  border: 1px solid #e8e8ed;
  border-radius: 8px;
  background: #fafafa;
  color: #1a1a2e;
  font-size: 15px;
  text-align: center;
}
.ed-input:focus {
  outline: none;
  border-color: #5b4fcf;
  box-shadow: 0 0 0 3px rgba(91, 79, 207, 0.12);
}
.ed-unit {
  font-size: 13px;
  font-weight: 700;
  color: #1a1a2e;
}
.ed-dialog-footer {
  border-top: 1px solid #f0f0f5;
  padding: 1rem 1.75rem 1.5rem;
  display: flex;
  justify-content: flex-end;
  gap: 0.75rem;
}
.ed-cancel-btn,
.ed-save-btn {
  height: 36px;
  border-radius: 8px;
  padding: 0 18px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
}
.ed-cancel-btn {
  border: 1px solid #e0e0ea;
  background: #fff;
  color: #5b4fcf;
}
.ed-save-btn {
  border: none;
  background: #5b4fcf;
  color: #fff;
}
.ed-save-btn:hover {
  background: #4338ca;
}
</style>



// WEBPACK FOOTER //
// EditDistance.vue?53a997f6